import React from 'react';
import { Switch, Route } from 'react-router-dom';
import projects from '../pages/projects';
import home from '../pages/home';

/*
function Main (){
    return (
      <Switch>
        <Route exact path="/landing" component={landing} />
        <Route exact path="/" component={home} />
        <Route path="/aboutme" component={about} />
        <Route path="/resume" component={resume} />
        <Route path="/projects" component={projects} />
      </Switch>
    );
}
*/
function Main() {
  return (
    <Switch>
      <Route exact path="/" component={home} />
      <Route path="/projects" component={projects} />
    </Switch>
  );
}
export default Main;